/** Site-scoped in-memory lobby catalog cache. Session Map only. Not financial APIs. */

export const LOBBY_CACHE_TTL_MS = 60000;

const store = new Map();
const inflight = new Map();

export function lobbyGamesCacheKey({
  siteId = '',
  currency = '',
  category = '',
  provider = 'all',
  page = 1,
  limit = 24,
  q = '',
} = {}) {
  const prov = !provider || provider === 'all' ? 'all' : String(provider);
  return [
    'games',
    String(siteId || ''),
    String(currency || ''),
    String(category || ''),
    prov,
    String(page || 1),
    String(limit || 24),
    String(q || '').trim(),
  ].join('|');
}

export function lobbyProvidersCacheKey({
  siteId = '',
  currency = '',
  category = '',
} = {}) {
  return ['providers', String(siteId || ''), String(currency || ''), String(category || '')].join('|');
}

export function readLobbyCache(key) {
  const hit = store.get(key);
  if (!hit) return null;
  if (Date.now() > hit.expiresAt) {
    store.delete(key);
    return null;
  }
  return hit.value;
}

export function writeLobbyCache(key, value, ttlMs = LOBBY_CACHE_TTL_MS) {
  store.set(key, { value, expiresAt: Date.now() + Number(ttlMs || LOBBY_CACHE_TTL_MS) });
}

export function cloneLobbyPage(page) {
  const rows = Array.isArray(page) ? page.slice() : [];
  const pagination = page && page.pagination ? { ...page.pagination } : undefined;
  return Object.assign(rows, pagination ? { pagination } : {});
}

export function isLobbyAbortError(err) {
  if (!err) return false;
  if (err.name === 'AbortError') return true;
  const msg = String(err.message || err);
  return /aborted|AbortError/i.test(msg);
}

export function dedupeLobbyFetch(key, producer) {
  const existing = inflight.get(key);
  if (existing) return existing;
  const pending = Promise.resolve()
    .then(producer)
    .finally(() => {
      if (inflight.get(key) === pending) inflight.delete(key);
    });
  inflight.set(key, pending);
  return pending;
}

export function __resetLobbyCacheForTests() {
  store.clear();
  inflight.clear();
}
